import React, { useState } from "react";
import "./sidebar.css";
import { IoSpeedometerSharp } from "react-icons/io5";
import { BsBarChartLine } from "react-icons/bs";
import {TfiIdBadge } from "react-icons/tfi";
import { TfiTruck } from "react-icons/tfi";
import { TfiPackage } from "react-icons/tfi";
import { LuLayoutGrid } from "react-icons/lu";
import { RiArrowDropDownLine } from "react-icons/ri";
import { Link, useNavigate } from "react-router";

const Sidebar = () => {
  const [isSalesOpen, setIsSalesOpen] = useState(false);
  const [isDriverOpen, setIsDriverOpen] = useState(false);


  return (
    <div
      className="bg-light text-white p-3 sidebar-div"
    >
      <h4 className="text-center mb-4">
        <img src="../images/logo.jpeg" width="100px" />
      </h4>
      <ul className="nav flex-column">
        <li className=" mb-2">
          <Link
            className="nav-link fw-bold bg-custom-blue ms-3"
            to="/dashboard"
          >
            <span className="icon-spacing">
              <IoSpeedometerSharp />
            </span>
            Dashboard
          </Link>
        </li>

        {/* Sales and Marketing */}

        <ul className="nav flex-column">
          {/* Dropdown Menu Item */}
          <li>
            <button
              className="nav-link fw-bold d-flex justify-content-between align-items-center w-100 bg-transparent border-0 ms-3 pb-3"
              onClick={() => setIsSalesOpen(!isSalesOpen)}
            >
              <span>
                <i className=" fa-solid fa-gauge me-2 icon-spacing">
                  {" "}
                  <span>
                    <BsBarChartLine />
                  </span>
                </i>
                Master
              </span>

              <span className={isSalesOpen ? "rotate-down" : "rotate-right"}>
                <RiArrowDropDownLine />
              </span>
            </button>

            {/* Submenu - Conditionally Rendered */}
            {isSalesOpen && (
              <ul className="nav flex-column ps-4">
                <li className="nav-item text-sm sidebar-li">
                  <Link className="nav-link " to="/Master/HomeDetail">
                    <i className=" fa-solid fa-gauge me-2 icon-spacing"></i>
                    Home Detail
                  </Link>
                </li>
                <li className="nav-item text-sm">
                  <Link className="nav-link " to="/Master/Banner">
                    <i className=" fa-solid fa-gauge me-2 icon-spacing"></i>
                    Banner
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/Master/AddRooms">
                    <i className=" fa-solid fa-gauge me-2 icon-spacing"></i>
                    Add Rooms
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/Master/HomeDescription">
                    <i className=" fa-solid fa-gauge me-2 icon-spacing"></i>
                    Home Description
                  </Link>
                </li>
              </ul>
            )}
          </li>
        </ul>

        {/* Human Resource */}

        <ul className="nav flex-column">
          {/* Dropdown Menu Item */}
          <li>
            <button className="nav-link fw-bold d-flex justify-content-between align-items-center w-100 bg-transparent border-0 ms-3 ">
              <span>
                <Link to="/Location/Address">
                  <i className="fa-solid fa-gauge me-2 icon-spacing">
                    {" "}
                    <span>
                      <TfiIdBadge />
                    </span>
                  </i>
                  Location
                </Link>
              </span>
            </button>
          </li>
        </ul>

        {/* Gallery */}
        <ul className="nav flex-column">
          {/* Dropdown Menu Item */}
          <li>
            <button className="nav-link fw-bold d-flex justify-content-between align-items-center w-100 bg-transparent border-0 ">
              <span>
                <Link className="nav-link" to="/Gallery">
                  <i className="fa-solid fa-gauge me-2 icon-spacing">
                    <span>
                      <TfiTruck />
                    </span>
                  </i>
                  Gallery
                </Link>
              </span>
            </button>
          </li>
        </ul>

        {/*Asset Management  */}
        <ul className="nav flex-column">
          {/* Dropdown Menu Item */}
          <li>
            <button className="nav-link fw-bold d-flex justify-content-between align-items-center w-100 bg-transparent border-0 ">
              <span>
                <Link className="nav-link" to="/Amenities">
                  <i className="fa-solid fa-gauge me-2">
                    {" "}
                    <span>
                      <TfiPackage />
                    </span>
                  </i>
                  Amenities
                </Link>
              </span>
            </button>
          </li>
        </ul>

        {/* Contact */}
        <ul className="nav flex-column">
          {/* Dropdown Menu Item */}
          <li>
            <button
              className="nav-link fw-bold d-flex justify-content-between align-items-center w-100 bg-transparent border-0 ms-3 "
              onClick={() => setIsDriverOpen(!isDriverOpen)}
            >
              <span>
                <Link>
                  <i className="fa-solid fa-gauge me-2 icon-spacing">
                    {" "}
                    <span>
                      <TfiIdBadge />
                    </span>
                  </i>
                  Contact
                </Link>
              </span>
              <span className={isDriverOpen ? "rotate-down" : "rotate-right"}>
                <RiArrowDropDownLine />
              </span>
            </button>

            {/* Submenu - Conditionally Rendered */}
            {isDriverOpen && (
              <ul className="nav flex-column ps-4">
                <li className="nav-item">
                  <Link className="nav-link" to="/Contact-Detail">
                    <i className=" fa-solid fa-gauge me-2 icon-spacing"></i>
                    Contact Detail
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/Contact">
                    <i className=" fa-solid fa-gauge me-2 icon-spacing"></i>
                    Contact Entries
                  </Link>
                </li>
              </ul>
            )}
          </li>
        </ul>

        {/* Transports */}
        <ul className="nav flex-column">
          {/* Dropdown Menu Item */}
          <li>
            <button className="nav-link fw-bold d-flex justify-content-between align-items-center w-100 bg-transparent border-0 ">
              <span>
                <Link className="nav-link" to="/Policies">
                  <i className="fa-solid fa-gauge me-2 icon-spacing">
                    {" "}
                    <span>
                      <TfiTruck />
                    </span>
                  </i>
                  Policies
                </Link>
              </span>
            </button>
          </li>
        </ul>

        <ul className="nav flex-column">
          {/* Dropdown Menu Item */}
          <li>
            <button className="nav-link fw-bold d-flex justify-content-between align-items-center w-100 bg-transparent border-0 ">
              <span>
                <Link className="nav-link" to="/Blog">
                  <i className="fa-solid fa-gauge me-2 icon-spacing">
                    {" "}
                    <span>
                      <TfiTruck />
                    </span>
                  </i>
                  Blog
                </Link>
              </span>
            </button>
          </li>
        </ul>

        {/* Feedback */}
        <ul className="nav flex-column">
          {/* Dropdown Menu Item */}
          <li>
            <button className="nav-link fw-bold d-flex justify-content-between align-items-center w-100 bg-transparent border-0 ">
              <span>
                <Link className="nav-link" to="/Feedback">
                  <i className="fa-solid fa-gauge me-2 icon-spacing">
                    {" "}
                    <span>
                      <LuLayoutGrid />
                    </span>
                  </i>
                  Feedback
                </Link>
              </span>
            </button>
          </li>
        </ul>

        <ul className="nav flex-column">
          {/* Dropdown Menu Item */}
          <li>
            <button className="nav-link fw-bold d-flex justify-content-between align-items-center w-100 bg-transparent border-0 ">
              <span>
                <Link className="nav-link" to="/Booking">
                  <i className="fa-solid fa-gauge me-2 icon-spacing">
                    {" "}
                    <span>
                      <LuLayoutGrid />
                    </span>
                  </i>
                  Booking Entries
                </Link>
              </span>
            </button>
          </li>
        </ul>
      </ul>
    </div>
  );
};

export default Sidebar;
